import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { _formatPrice } from "../../../../../../shared/helpers/utils";
import { formatDate } from "../../../exportreport/utils";

const CustomBarChart = ({ theme, data, height = 300, isWeekly, secondValue=true, legendNames }) => {
  const maxValue = Math.max(...data.map((item) => item.value));
  // Map legend keys to display names
  
  
  // Custom Legend Formatter
  const legendFormatter = (value) => (
    <span className={`custom-legend-text ${value}`}>{legendNames && legendNames[value] ? legendNames[value] : value}</span>
  );
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: -20, bottom: 0 }}
      >
        <XAxis
          dataKey="date"
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 18,
            fontWeight: 600,
          }}
          angle={-45}
          textAnchor="end"
          padding={{ left: 20, right: 20 }}
          height={100}
          interval={0} 
        />

        <YAxis
          axisLine={{ stroke: theme === "dark" ? "#f8ffef" : "#eee" }}
          tickLine={false}
          domain={[0, maxValue]}
          tick={{
            fill: theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)",
            fontSize: 18,
            fontWeight: 600,
          }}
         tickFormatter={(value) => (value === 0 ? "" : value)}
        />
        {legendNames ? <Legend formatter={legendFormatter} /> : null}
        <Bar
          dataKey="value1"
          className="bar-element-chart"
          fill={theme === "dark" ? "#f8ffef" : "rgb(102, 102, 102)"}
        />
        

      {secondValue ?  <Bar
          dataKey="value2"
          className="opacity-bar-element-chart1"
          fill={theme === "dark" ? "#f4a261" : "rgb(96, 165, 250)"}
        />:null}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CustomBarChart;
